import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import { Logo } from "@/components/header/Logo";
import { DesktopNav, HeaderActions } from "@/components/header/DesktopNav";
import { MobileMenu } from "@/components/header/MobileMenu";

export { Logo };

const useScrolled = (threshold = 24) => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > threshold);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [threshold]);
    return scrolled;
};

export default function Header() {
    const [open, setOpen] = useState(false);
    const scrolled = useScrolled();
    const location = useLocation();
    const navigate = useNavigate();

    const go = (target) => {
        setOpen(false);
        const item = typeof target === "string" ? { id: target } : target;
        if (item.to) {
            navigate(item.to);
            return;
        }
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => scrollToId(item.id), 120);
        } else {
            scrollToId(item.id);
        }
    };

    return (
        <>
            <header
                data-testid="site-header"
                className={`fixed inset-x-0 top-0 z-40 border-b transition-colors duration-300 ${
                    scrolled
                        ? "border-white/10 bg-tl-dark/90 backdrop-blur-md"
                        : "border-white/5 bg-tl-dark/40 backdrop-blur-sm"
                }`}
            >
                <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
                    <Logo onClick={() => go("home")} />
                    <DesktopNav onGo={go} />
                    <HeaderActions onGo={go} onOpenMenu={() => setOpen(true)} />
                </div>
            </header>
            <MobileMenu open={open} onClose={() => setOpen(false)} onGo={go} />
        </>
    );
}
